import React, { useEffect, useRef } from 'react';
import { listThemes, applyTheme, THEME_ORDER, type ThemeId } from '../../brand/colors/themes';

// Simple demo card reusing existing UI classes
function DemoSection({ id, title }: { id: ThemeId; title: string }) {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (ref.current) {
      applyTheme(ref.current, id);
    }
  }, [id]);

  return (
    <section ref={ref} className="rounded-2xl border border-border/60 bg-surface p-6 space-y-4">
      <div>
        <h3 className="font-heading text-xl text-heading">{title}</h3>
        <p className="text-text-muted text-sm">
          This section demonstrates the data-theme="{id}" behavior.
        </p>
      </div>
      <div className="flex gap-3">
        <button className="bg-primary text-primary-foreground px-4 py-2 rounded-lg font-medium shadow-sm hover:shadow-md transition-shadow">
          Primary
        </button>
        <button className="bg-accent text-accent-foreground px-4 py-2 rounded-lg font-medium shadow-sm hover:shadow-md transition-shadow">
          Accent
        </button>
      </div>
      <div className="mt-2 text-xs text-text-muted font-mono">
        Primary: <span className="text-primary">■</span> Accent:{' '}
        <span className="text-accent">■</span>
      </div>
    </section>
  );
}

export default function ThemeSectionsDemo() {
  const themes = listThemes();
  return (
    <div className="mx-auto max-w-6xl space-y-6 px-4 py-8">
      <div className="space-y-3">
        <h1 className="font-heading text-4xl text-heading">Theme Sections (Dev Demo)</h1>
        <p className="text-text-muted text-lg">
          Hidden dev page: shows the same content section rendered with each of the 8 approved theme
          presets.
        </p>
        <p className="text-text-muted text-sm">
          Each section below has a <code className="bg-code px-2 py-1 rounded">data-theme</code>{' '}
          attribute that scopes all color tokens to that theme preset.
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        {THEME_ORDER.map((id) => (
          <DemoSection key={id} id={id} title={id} />
        ))}
      </div>
    </div>
  );
}
